import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { ListingOpvalSticker } from '@/client/components/ListingsNew/components';
import { ListingFigureProps } from './types';
import ListingFigure from './ListingListViewFigureRoot';

const ListingListViewFigure: React.FC<ListingFigureProps> = ({
  images,
  opvalStickerText,
  loadingType,
  decodingType,
  fetchPriority,
  isFavorite,
  onFavorite,
  descriptionElementId,
  urgencyFeatureActive,
  mainAspectRatio,
  subImagesAspectRatio,
  showFavoriteIcon = false,
  enableLandscapeContain = false,
}) => {
  const { t } = useI18nContext();
  const favoriteIconAriaLabel = isFavorite
    ? t('listing.favourite.actions.unfavoriting')
    : t('listing.favourite.actions.favoriting');

  return (
    <ListingFigure>
      {images.length === 0 && (
        <ListingFigure.NoImage
          aspectRatio={mainAspectRatio}
          favoriteIconAriaLabel={favoriteIconAriaLabel}
          isFavorite={isFavorite}
          onFavorite={onFavorite}
          showFavoriteIcon={showFavoriteIcon}
          descriptionElementId={descriptionElementId}
        />
      )}
      {images.length > 0 && (
        <ListingFigure.MainImage
          image={images[0]}
          fetchPriority={fetchPriority}
          loadingType={loadingType}
          decodingType={decodingType}
          favoriteIconAriaLabel={favoriteIconAriaLabel}
          isFavorite={isFavorite}
          onFavorite={onFavorite}
          showFavoriteIcon={showFavoriteIcon}
          descriptionElementId={descriptionElementId}
          urgencyFeatureActive={urgencyFeatureActive}
          aspectRatio={mainAspectRatio}
          enableLandscapeContain={enableLandscapeContain}
        />
      )}
      {images.length > 2 && (
        <ListingFigure.SubImages
          images={images}
          fetchPriority={fetchPriority}
          loadingType={loadingType}
          decodingType={decodingType}
          aspectRatio={subImagesAspectRatio}
          enableLandscapeContain={enableLandscapeContain}
        />
      )}
      {opvalStickerText && <ListingOpvalSticker>{opvalStickerText}</ListingOpvalSticker>}
    </ListingFigure>
  );
};

export default ListingListViewFigure;
